<template>
    <div class="today-view-session__image">
        <img v-if="event.imageUrl"
             :alt="event.name"
             :src="event.imageUrl" />
        <span v-else
              class="today-view-session__image__initial"
              :class="{
                  'today-view-session__image__initial--shift-left': shiftInitialLeft,
                  'today-view-session__image__initial--shift-right': shiftInitialRight,
                  'today-view-session__image__initial--shift-down': shiftInitialDown,
                  'today-view-session__image__initial--shift-up': shiftInitialUp,
              }">
            {{ initial }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        event: {
            type: Object,
            required: true,
        },
    },

    computed: {
        initial() {
            return this.event.name.substr(0, 1).toUpperCase();
        },

        /**
         * Some letters just don't seem to look centered.
         * Shift these ones 1px to the left to make them look better.
         *
         * @return {boolean}
         */
        shiftInitialLeft() {
            return ['C', 'W'].indexOf(this.initial) !== -1;
        },

        shiftInitialRight() {
            return ['D', 'J'].indexOf(this.initial) !== -1;
        },

        shiftInitialDown() {
            return [].indexOf(this.initial) !== -1;
        },

        shiftInitialUp() {
            return ['Q', 'J'].indexOf(this.initial) !== -1;
        },
    },
};
</script>

<style lang="less">
@import "../../../../../less/variables";

.today-view-session__image {
    display: block;
    border-radius: 50%;
    background: @dark-grey-alt;
    overflow: hidden;

    &,
    > img,
    .today-view-session__image__initial {
        width: 35px;
        height: 35px;
    }

    > img {
        border-radius: 50%;
    }

    .today-view-session__image__initial {
        user-select: none;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @white;
        font-size: 21px;
        font-weight: bold;
        text-align: center;
        position: relative;

        &.today-view-session__image__initial--shift-left {
            left: -1px;
        }

        &.today-view-session__image__initial--shift-right {
            left: 1px;
        }

        &.today-view-session__image__initial--shift-down {
            top: 1px;
        }

        &.today-view-session__image__initial--shift-up {
            top: -1px;
        }
    }
}

@media (min-width: @non-mobile-min) {
    .today-view-session__image {
        &,
        > img,
        .today-view-session__image__initial {
            width: 50px;
            height: 50px;
        }

        .today-view-session__image__initial {
            font-size: 31px;
            top: -1px;
        }
    }
}
</style>
